import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ScrollToHash } from './components/ScrollToHash';
import { Home } from './pages/Home';
import { NeighborhoodPage } from './pages/NeighborhoodPage';
import { neighborhoods } from './data/neighborhoods';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2rkx67l5bqppn">
      <BrowserRouter data-id="element-1" data-mp="2rk46330veygh">
        <ScrollToHash data-id="element-2" data-mp="2rlp10tr3kjev" />
        <div className="min-h-screen w-full bg-white font-sans text-neutral-900" data-id="element-3" data-mp="2rit2b37fdqpd">
          <Routes data-id="element-4" data-mp="2mndqshww46w4">
            <Route path="/" element={<Home data-id="element-6" data-mp="31agnimde2bie" />} data-id="element-5" data-mp="2mjpxnjvcxmhx" />
            {neighborhoods.map(neighborhood => <Route key={neighborhood.slug} path={`/${neighborhood.slug}`} element={<NeighborhoodPage slug={neighborhood.slug} data-id="element-8" data-mp="28ufm24yk52fw" />} data-id="element-7" data-mp="31cjmvx0flgzs" />)}
            <Route path="*" element={<Navigate to="/" replace data-id="element-10" data-mp="23vuoyeelqyvo" />} data-id="element-9" data-mp="23vcjcr61v8b3" />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}